import { Skeleton } from '@mui/material';
import { BrokerCard as BrokerCardWrapper } from '../../styled';

export const BrokerCardSkeleton = () => (
  <BrokerCardWrapper>
    <Skeleton variant="circular" width={44} height={44} animation="wave" sx={{ flexShrink: 0 }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <Skeleton variant="text" width="60%" height={20} animation="wave" />
      <Skeleton variant="text" width="80%" height={16} animation="wave" />
    </div>
    <Skeleton variant="rounded" width={72} height={32} animation="wave" sx={{ flexShrink: 0 }} />
  </BrokerCardWrapper>
);
